import React from 'react';
import { Button, Message } from 'semantic-ui-react';

const reviewTitleV815 = 'Review channel credentials';

export const ChannelSecretReviewButtonV815 = ({
  onReview,
  labeled = false,
}) => (
  <Button
    type='button'
    basic
    primary
    icon='eye'
    content={labeled ? 'Review' : undefined}
    aria-label={reviewTitleV815}
    title={reviewTitleV815}
    onClick={onReview}
  />
);

const ChannelSecretReviewNoticeV815 = ({ onReview }) => (
  <Message color='yellow'>
    <Message.Header>凭据已隐藏</Message.Header>
    <p>完成任一种两步验证后，可查看并编辑 10 分钟。</p>
    <ChannelSecretReviewButtonV815 labeled onReview={onReview} />
  </Message>
);

export default ChannelSecretReviewNoticeV815;
